export default __webpack_public_path__ + "static/media/Angularjs.f3fc62f3.gif";